export default {
  pico: 'Lodgepole Pine',
  pisi: 'Sitka Spruce',
  psme: 'Douglas-fir',
  pipo: 'Ponderosa Pine',
  pien: 'Engelmann Spruce',
  lariocc: 'Western larch',
  pinumon: 'Western white pine',
}
